import * as pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import { FormatedDate } from 'src/utils'
import { InstrucaoAdmissaoToPDf } from '../types'


type PropsLines = {
  text: string
  margin: [0, 6, 0, 0]
  alignment: 'center'
}

export async function handleDataToPDF(data: InstrucaoAdmissaoToPDf) {
  const logoTP =
    'data:image/png;base64,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'
  const logoG10 =
    'data:image/png;base64,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'

  let formatedAgendamentos: PropsLines[][] = []
  const nomeCompleto =
    data.admissaoCandidatoFK.candidatoFK.nomeCompleto

  const passos = data.passos

  for (let index = 0; index < data.AgendaInstrucao.length; index++) {
    const agendamento = data.AgendaInstrucao[index]
    const dataFormatada = FormatedDate(agendamento.data, true)
    let valueExist = false

    formatedAgendamentos.map(agenda => {
      const index = agenda.findIndex(a => a.text === dataFormatada)
      if (index !== -1) {
        valueExist = true
        if (agendamento.turno === 'MANHA') {
          agenda[1].text +=
            `${agenda[1].text ? ', ' : ''}` + agendamento.treinamentoFK?.nome ?? agendamento.comentario ?? '-'
        }
        if (agendamento.turno === 'TARDE') {
          agenda[2].text +=
            `${agenda[2].text ? ', ' : ''}` + agendamento.treinamentoFK?.nome ?? agendamento.comentario ?? '-'
        }
        if (agendamento.turno === 'NOITE') {
          agenda[3].text +=
            `${agenda[3].text ? ', ' : ''}` + agendamento.treinamentoFK?.nome ?? agendamento.comentario ?? '-'
        }
      }
    })
    if (!valueExist) {
      const formato: PropsLines[] = [
        {
          text: dataFormatada,
          margin: [0, 6, 0, 0],
          alignment: 'center'
        },
        {
          text: '',
          margin: [0, 6, 0, 0],
          alignment: 'center'
        },
        {
          text: '',
          margin: [0, 6, 0, 0],
          alignment: 'center'
        },
        {
          text: '',
          margin: [0, 6, 0, 0],
          alignment: 'center'
        }
      ]

      if (agendamento.turno === 'MANHA') {
        formato[1].text = agendamento.treinamentoFK?.nome ?? agendamento.comentario ?? '-'
      }
      if (agendamento.turno === 'TARDE') {
        formato[2].text = agendamento.treinamentoFK?.nome ?? agendamento.comentario ?? '-'
      }
      if (agendamento.turno === 'NOITE') {
        formato[3].text = agendamento.treinamentoFK?.nome ?? agendamento.comentario ?? '-'
      }
      formatedAgendamentos.push(formato)
    }
  }

  ; (<any>pdfMake).vfs = pdfFonts.pdfMake.vfs

  const pdf: TDocumentDefinitions = {
    pageOrientation: 'portrait',
    pageSize: 'A4',
    pageMargins: [15, 25, 15, 25],
    content: [
      {
        table: {
          widths: [130, 133, 133, 133],
          heights: [30, 30, 20],
          headerRows: 3,
          body: [
            [
              {
                image: 'url',
                fit: [100, 100],
                style: 'imagem',
                alignment: 'center',
                margin: [0, 12, 0, 0],
                rowSpan: 2,
                fillColor: '#f5f5f5'
              },
              {
                text: `${nomeCompleto}`,
                style: 'tableHeader',
                margin: [0, 6, 0, 0],
                colSpan: 3,
                alignment: 'center'
              },
              {},
              {}
            ],
            [
              {},
              {
                text: 'Treinamentos',
                style: 'tableHeader',
                margin: [0, 6, 0, 0],
                colSpan: 3,
                alignment: 'center'
              },
              {},
              {}
            ],
            [
              {
                text: 'DATA',
                style: 'tableHeader',
                margin: [0, 6, 0, 0],
                alignment: 'center'
              },
              {
                text: 'MANHÃ (08:00)',
                style: 'tableHeader',
                margin: [0, 6, 0, 0],
                alignment: 'center'
              },
              {
                text: 'TARDE (13:30)',
                style: 'tableHeader',
                margin: [0, 6, 0, 0],
                alignment: 'center'
              },
              {
                text: 'NOITE (19:00)',
                style: 'tableHeader',
                margin: [0, 6, 0, 0],
                alignment: 'center'
              }
            ],
            ...formatedAgendamentos
          ]
        }
      },
      {
        text: 'Após assinar a admissão, você deve seguir os passos abaixo:',
        style: 'textPassos'
      },
      {
        separator: ['(', ')'],
        ol: passos,
        style: 'listPassos'
      },
      {
        text: 'Aproveite ao máximo o seu tempo, não fique parado. Se precisar de ajuda procure o RH, ficaremos felizes em atendê-lo.',
        style: 'textFinal'
      },
      {
        text: 'Boa Viagem e Bom Trabalho!!!',
        style: 'textSaudacao'
      }
    ],
    images: {
      url: data.empresaFK && data.empresaFK.sigla === 'G10' ? logoG10 : logoTP
    },
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 12,
        fillColor: '#f5f5f5'
      },
      imagem: {
        margin: [0, 30, 0, 5],
        alignment: 'left'
      },
      textPassos: {
        color: '#000',
        fontSize: 12,
        margin: [10, 10, 3, 0],
        alignment: 'left'
      },
      listPassos: {
        color: '#000',
        fontSize: 12,
        margin: [10, 10, 6, 0],
        alignment: 'left'
      },
      textFinal: {
        fontSize: 10,
        margin: [10, 30, 3, 0],
        alignment: 'center'
      },
      textSaudacao: {
        color: '#000',
        fontSize: 12,
        bold: true,
        margin: [10, -2, 3, 0],
        alignment: 'center'
      }
    }
  }
  pdfMake.createPdf(pdf).download(`Instruções Admissão - ${nomeCompleto}`)
}
